import { Component, Inject, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EtiquettePilotageModel } from 'src/models/pilotage/etiquettePilotageModel';
import { EtiquetteService } from 'src/services/etiquette.service';
import { ModifierEtiquetteModel } from 'src/models/pilotage/modifierEtiquetteModel';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
    selector: 'app-modifier-etiquette-dialog',
    imports: [FormsModule, MatProgressSpinnerModule, TranslateModule],
    templateUrl: './modifier-etiquette-dialog.component.html',
    styleUrls: ['./modifier-etiquette-dialog.component.scss']
})
export class ModifierEtiquetteDialogComponent implements OnInit {
  etiquette: EtiquettePilotageModel;
  estEnCoursDeEnregistrement: boolean = false;
  entitesSelectionnees: { id: number, nom: string, estGroupe: boolean }[] = [];
  originalEntitesCount: number = 0;

  readonly LANGS = ['fr', 'en', 'es'];
  etiquetteLocales: { [key: string]: string } = {};

  constructor(
    public dialogRef: MatDialogRef<ModifierEtiquetteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EtiquettePilotageModel,
    private etiquetteService: EtiquetteService,
    private utilisateurService: UtilisateurService
  ) {
    this.etiquette = { ...data };
    this.LANGS.forEach(lang => {
      this.etiquetteLocales[lang] = this.etiquette.locales?.[lang] || '';
    });
  }

  ngOnInit(): void {
    this.initializeEntites();
  }

  initializeEntites(): void {
    const contexte = this.utilisateurService.contexteUtilisateur;

    this.etiquette.entiteIds.forEach(id => {
      const entite = contexte.entitesAccessibles.find(e => e.entiteId === id);
      if (entite) {
        this.entitesSelectionnees.push({
          id: entite.entiteId,
          nom: entite.nom,
          estGroupe: entite.estGroupe
        });
      }
    });

    this.originalEntitesCount = this.entitesSelectionnees.length;
  }

  boutonSauvegardeDesactive(): boolean {
    const noNameProvided = this.LANGS.every(lang => !this.etiquetteLocales[lang]);
    const noColorProvided = !this.etiquette.couleur;
    return noNameProvided || noColorProvided;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  saveEtiquette(): void {
    this.estEnCoursDeEnregistrement = true;

    const locales: { [key: string]: string } = {};
    for (const lang of this.LANGS) {
      locales[lang] = this.etiquetteLocales[lang] || '';
    }

    const etiquetteModifie: ModifierEtiquetteModel = {
      etiquetteId: this.etiquette.etiquetteId,
      locales,
      couleur: this.etiquette.couleur,
      visibleSurCertificats: this.etiquette.visibleSurCertificats,
    };

    this.etiquetteService.modifierEtiquette(etiquetteModifie).subscribe({
      next: () => {
        this.estEnCoursDeEnregistrement = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.estEnCoursDeEnregistrement = false;
      }
    });
  }
}
